// PostgREST equality filters use PostgreSQL array literals, not JSON arrays.
export function postgresTextArray(values) {
  return '{' + values.map(value => '"' + String(value).replaceAll('\\', '\\\\').replaceAll('"', '\\"') + '"').join(',') + '}'
}
